import { render } from "./index.vue?vue&type=template&id=bedc9c6e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-bedc9c6e"

export default script